import React, { useContext, useEffect, useState, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'
import { observer } from 'mobx-react'
import AppInput, { AppInputWithTail } from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import PageSubHeader from '../../components/common/page_sub_header'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { API_URL, FORMAT } from '../../config/const'
import CKEditor from '@ckeditor/ckeditor5-react'
import { chkNoteTitle, fphoto, formatNumber } from '../../helper/common'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import { ko } from 'date-fns/locale'
import EmojiInput from '../../components/control/custom_input/emoji_input'
import { rootStore } from '../../mobx/store'

const ProductNew = observer((props) => {
  const moment = require('moment')
  const context = useContext(Page_settings)
  const [productId, setProductId] = useState(null)
  const [itemName, setItemName] = useState('')
  const [price, setPrice] = useState('')
  const [period, setPeriod] = useState('')
  const [isUseOpenTime, setIsUseOpenTime] = useState(true)
  const [openTime, setOpenTime] = useState(null)
  const [isUseCloseTime, setIsUseCloseTime] = useState(true)
  const [closeTime, setCloseTime] = useState(null)
  const [desc, setDesc] = useState('')
  const [noteError, setNoteError] = useState('')
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let product_id = parseInt(props.match.params.product_id)
    if (product_id) {
      getProduct(product_id);
    }

  }, []);

  useEffect(() => {
    // setEnabled(itemName !== '' && price !== '' && period != '' && (!isUseOpenTime || (isUseOpenTime && openTime !== null)) && (!isUseCloseTime || (isUseCloseTime && closeTime !== null)))
     setEnabled(itemName !== '' && price !== '' && period != '')
  }, [itemName, price, period])

  const getProduct = (product_id) => {
    const requestData = {
      id: product_id
    };

    context.post(
      'product/get_my_product_list',
      requestData,
      (response) => {
        const product = response.products?.[0];
        setProductId(product.id);
        setItemName(product.name);
        setPrice(product.price);
        setPeriod(product.period);
        setOpenTime(product.open);
        setIsUseOpenTime(product.open ? true : false);
        setCloseTime(product.close);
        setIsUseCloseTime(product.close ? true : false);
        setDesc(product.description);
      },
      true,
      (err) => {
        context.showAlert(err.msg);
      }
    );
  }

  const setToggleSellTime = (timeType) => {
    if (timeType == 'open') {
      setIsUseOpenTime((prev) => !prev);
    } else {
      setIsUseCloseTime((prev) => !prev);
    }
  }


  const setItemSellTime = (v, timeType) => {
    const selectedTime = moment(v);
    if (selectedTime.isValid()) {
      if (timeType == 'open') {
        setOpenTime(selectedTime.format(FORMAT.DATE_TIME));
      } else {
        setCloseTime(selectedTime.format(FORMAT.DATE_TIME));
      }

    }
  }

  const setDescription = (v) => {
    setDesc(v);
    if (v !== '' && (v.length > 250 || v.length < 2)) {
      setNoteError(strings.intro_note_error)
    } else {
      setNoteError('')
    }
  }

  const validatePrice = (inputValue) => {
    const input = inputValue.replace(/,/g, ''); // 쉼표 제거
    if (!/^\d*$/.test(input)) return; // 숫자만 허용
    if (input == 0) {
      setPrice('');
      return;
    }
    const formattedValue = parseInt(input || '0', 10).toLocaleString(); // 쉼표 추가
    setPrice(formattedValue);
  };

  const validatePeriod = (inputValue) => {
    const input = inputValue.replace(/,/g, ''); // 쉼표 제거
    if (!/^\d*$/.test(input)) return; // 숫자만 허용
    setPeriod(input);
  };

  const onSave = () => {
    const requestData = {
      mp_name: itemName,
      mp_description: desc,
      mp_category: 'period',
      mp_open_time: isUseOpenTime ? openTime : null,
      mp_close_time: isUseCloseTime ? closeTime : null,
      mp_price: price.replace(/,/g, ''),
      mp_period: period,
    };

    if (productId) {
      requestData['mp_id'] = productId;
      context.post(
        'product/update_product',
        requestData,
        () => {
          context.showAlert(
            strings.product_updated_successfully,
            () => {
              props.history.replace('/product_info');
            },
            strings.confirm
          );
        },
        true,
        (err) => {
          context.showAlert(err.msg);
        }
      );
    } else {
      context.post(
        'product/add_product',
        requestData,
        () => {
          context.showAlert(
            strings.product_saved_successfully,
            () => {
              props.history.replace('/product_info');
            },
            strings.confirm
          );
        },
        true,
        (err) => {
          context.showAlert(err.msg);
        }
      );
    }

  };

  return (
    <React.Fragment>
      <div className='content-container'>
        <div className='im-container im-container-no-sidebar'>
          <PageSubHeader pageName={strings.product_new} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={strings.product_new} />
          <div className='al-header mt-30 sm-mt-15 fs-18 sm-fs-16 f-b'>{`${strings.package_item} ${productId ? strings.package_item_modify : strings.package_item_new}`}</div>
          <div className='al-content'>
            <label className='control-label'>{strings.item_name}<span className='text-danger'>*</span></label>
            <EmojiInput className={''} errorMsg={''} placeholder={strings.item_name_hint} inputType={'text'} maxLength={100} value={itemName} onChange={setItemName} />
            <label className='control-label mt-20'>{strings.item_price}<span className='text-danger'>*</span></label>
            <AppInputWithTail center={true} errorMsg={''} placeholder={strings.item_price_hint} inputType={'tel'} value={price} tail={'P'} onChange={(v) => { validatePrice(v) }} />

            <label className='control-label mt-20'>{strings.item_period}<span className='text-danger'>*</span></label>
            <AppInputWithTail center={true} errorMsg={''} placeholder={strings.item_period_hint} inputType={'tel'} value={period} tail={'일'} onChange={(v) => { validatePeriod(v) }} />

            { /*
            <label className='control-label mt-20'>{strings.item_open_time}</label>
            <img className='is_on cursor-point ml-20' src={isUseOpenTime ? '/assets/image/is_on.png' : '/assets/image/is_off.png'} alt='' onClick={() => setToggleSellTime('open')} />
            <DatePicker
              placeholderText={strings.item_open_time_hint}
              locale={ko}
              disabled={!isUseOpenTime}
              dateFormat="yyyy-MM-dd HH:mm"
              className={'d-block'}
              showTimeSelect
              timeIntervals={10}
              timeCaption="시간"
              selected={openTime === '' || openTime == null ? null : new Date(openTime)}
              onChange={(date) => {
                setItemSellTime(date, 'open');
              }}
              renderCustomHeader={({
                date,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div className='react-datepicker-flex'>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                  >
                    <img src={'/assets/image/nav-arrow-left.png'} alt='' width={16} height={16} />
                  </button>
                  <h2 className="react-datepicker__current-month">{date.getFullYear()}년 {date.getMonth() + 1}월</h2>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                  >
                    <img src={'/assets/image/nav-arrow-right.png'} alt='' width={16} height={16} />
                  </button>
                </div>
              )}
            />

            <label className='control-label mt-20'>{strings.item_close_time}</label>
            <img className='is_on cursor-point  ml-20' src={isUseCloseTime ? '/assets/image/is_on.png' : '/assets/image/is_off.png'} alt='' onClick={() => setToggleSellTime('close')} />
            <DatePicker
              placeholderText={strings.item_close_time_hint}
              locale={ko}
              disabled={!isUseCloseTime}
              dateFormat="yyyy-MM-dd HH:mm"
              className={'d-block'}
              showTimeSelect
              timeIntervals={10}
              timeCaption="시간"
              selected={closeTime == '' || closeTime == null ? null : new Date(closeTime)}
              onChange={(date) => {
                setItemSellTime(date, 'close');
              }}
              renderCustomHeader={({
                date,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div className='react-datepicker-flex'>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                  >
                    <img src={'/assets/image/nav-arrow-left.png'} alt='' width={16} height={16} />
                  </button>
                  <h2 className="react-datepicker__current-month">{date.getFullYear()}년 {date.getMonth() + 1}월</h2>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                  >
                    <img src={'/assets/image/nav-arrow-right.png'} alt='' width={16} height={16} />
                  </button>
                </div>
              )}
            />
*/}
            <label className='control-label fs-20 sm-fs-16 f-b mt-30 sm-mt-20 mb-0'>{strings.item_description}</label>
            <div className={'mt-18 sm-mt-12'}>
              <div className={'position-relative'}>
                <textarea className={'form-control form-control1 ' + (noteError !== '' ? 'error ' : '')} id={'note'} required={false} value={desc} onChange={(v) => { setDescription(v.target.value) }} maxLength={250} />
                <label className='form-control-placeholder' htmlFor='note'>{strings.item_description_hint}{<span className='ml-16 fs-14'>{'/250' + strings.max_length}</span>}</label>
              </div>
              <div className={'invalid-feedback ' + (noteError !== '' ? 'error' : '')}>{noteError}</div>
            </div>
            <ConfirmButton enabled={enabled} className={'btn btn-login mt-60 sm-mt-30 fs-15 sm-fs-14 f-m '} onClick={() => onSave()} text={strings.registering} />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(ProductNew)
